import { useCallback, useEffect, useState } from 'react';
import {
  getLikedProductIds,
  toggleLikedProduct,
} from '@/lib/menu/productLikesStorage';
import { trackProductLike, trackProductUnlike } from '@/lib/analytics/trackEvent';

export function useProductLikes(businessId) {
  const [likedIds, setLikedIds] = useState(() => new Set(getLikedProductIds(businessId)));

  useEffect(() => {
    setLikedIds(new Set(getLikedProductIds(businessId)));
  }, [businessId]);

  const isLiked = useCallback(
    (productId) => likedIds.has(String(productId || '').trim()),
    [likedIds],
  );

  const toggleLike = useCallback(
    (productId) => {
      const pid = String(productId || '').trim();
      if (!businessId || !pid) return false;
      const { liked, ids } = toggleLikedProduct(businessId, pid);
      setLikedIds(new Set(ids));
      if (liked) trackProductLike(pid, businessId);
      else trackProductUnlike(pid, businessId);
      return liked;
    },
    [businessId],
  );

  return { isLiked, toggleLike, likedIds };
}
